<template>
  <section class="page">
    <v-row no-gutters class="px-3">
      <v-col cols="12" class="pa-0">
        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-acts
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
              >
              </template-chart-acts>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-acts
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
              >
              </template-chart-acts>
            </v-col>
          </v-row>
        </keep-alive>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-acts-io
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
              >
              </template-chart-acts-io>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-acts-io
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
              >
              </template-chart-acts-io>
            </v-col>
          </v-row>
        </keep-alive>

        <div class="page-break"></div>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-external
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-external>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-external
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-external>
            </v-col>
          </v-row>
        </keep-alive>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-external-kpi
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-external-kpi>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-external-kpi
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-external-kpi>
            </v-col>
          </v-row>
        </keep-alive>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-internal-kpi
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-internal-kpi>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-internal-kpi
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-internal-kpi>
            </v-col>
          </v-row>
        </keep-alive>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-ycs
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-ycs>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-ycs
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-ycs>
            </v-col>
          </v-row>
        </keep-alive>

          <div class="page-break"></div>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-fees
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-fees>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-fees
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-fees>
            </v-col>
          </v-row>
        </keep-alive>

        <keep-alive>
          <v-row>
            <v-col :cols="period == 2 ? 6 : 12" :class="period == 2 ? 'pl-6 pr-1 py-1' : 'py-1 px-6'">
              <template-chart-fees-sales
                :item="items[skey]"
                :yyyy="period == 2 ? yyyy - 1 : yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-fees-sales>
            </v-col>
            <v-col v-if="period == 2" cols="6" class="pr-6 pl-1 py-1">
              <template-chart-fees-sales
                :item="items[skey]"
                :yyyy="yyyy"
                :mm="mm"
                :value="value"
                :group="group"
                :prev="prev"
                :plan="plan"
                >
              </template-chart-fees-sales>
            </v-col>
          </v-row>
        </keep-alive>
      </v-col>
      <span v-if="item" class="my-footer mr-4">{{ item.schools.name }}</span>
    </v-row>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplateChart from './TemplateChart.vue'
import TemplateChartActs from './TemplateChartActs.vue'
import TemplateChartYCS from './TemplateChartYCS.vue'
import TemplateChartActsIO from './TemplateChartActsIO.vue'
import TemplateChartExternal from './TemplateChartExternal.vue'
import TemplateChartExternalKPI from './TemplateChartExternalKPI.vue'
import TemplateChartInternalKPI from './TemplateChartInternalKPI.vue'
import TemplateChartFees from './TemplateChartFees.vue'
import TemplateChartFeesSales from './TemplateChartFeesSales.vue'

Vue.component('template-chart', TemplateChart)
Vue.component('template-chart-acts', TemplateChartActs)
Vue.component('template-chart-ycs', TemplateChartYCS)
Vue.component('template-chart-acts-io', TemplateChartActsIO)
Vue.component('template-chart-external', TemplateChartExternal)
Vue.component('template-chart-external-kpi', TemplateChartExternalKPI)
Vue.component('template-chart-internal-kpi', TemplateChartInternalKPI)
Vue.component('template-chart-fees', TemplateChartFees)
Vue.component('template-chart-fees-sales', TemplateChartFeesSales)

export default {
  props: ['items', 'item', 'skey', 'yyyy', 'mm', 'options', 'period', 'value', 'group', 'prev', 'plan'],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 48) + 'px;'
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style>
@media print {
  .chartjs-render-monitor {
    height: auto!important;
    width: 100% !important;
  }

  #bar-chart {
    height: 100% !important;
    width: 100% !important;
  }

  #line-chart {
    height: 100% !important;
    width: 100% !important;
  }
  .page-break {
    display: block;
    break-before: always;
    page-break-before: always;
    padding-bottom: 20px;
  }
}
@page {
    margin: 0mm;
}
</style>
